function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

var _dec, _dec2, _dec3, _class;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

import { DragAndDrop, modalify } from "zengular-ui";
import { Brick } from "zengular";
import twig from "./magic-attachments.twig";
import copy from "copy-text-to-clipboard";
import "./magic-attachments.scss";
import { getClassNameForExtension } from "font-awesome-filetypes";
import Contextmenu from "zengular-ui/contextmenu/contextmenu";
import MagicImageEditorModal from "./magic-image-editor.modal";
import { Handler } from "zengular-magic";
/**
 * @property {Handler} handler
 */

var MagicAttachmentsModal = (_dec = modalify(), _dec2 = Brick.register('magic-attachments', twig), _dec3 = Brick.renderOnConstruct(false), _dec(_class = _dec2(_class = _dec3(_class = /*#__PURE__*/function (_Brick) {
  _inherits(MagicAttachmentsModal, _Brick);

  var _super = _createSuper(MagicAttachmentsModal);

  function MagicAttachmentsModal() {
    _classCallCheck(this, MagicAttachmentsModal);

    return _super.apply(this, arguments);
  }

  _createClass(MagicAttachmentsModal, [{
    key: "beforeRender",
    value: function beforeRender(args) {
      var _this = this;

      if (args) {
        this.collections = {};
        if (Array.isArray(args.collections)) args.collections.forEach(function (collection) {
          return _this.collections[collection.name] = collection;
        });else this.collections = args.collections;
        this.handler = args.handler;
        this.id = args.id;
        this.api = args.api ? args.api : this.handler.api + '/attachment';
      }
    }
  }, {
    key: "onInitialize",
    value: function onInitialize() {
      var _this2 = this;

      this.menu = new Contextmenu();
      this.menu.add('Download', 'fas fa-cloud-download-alt').click(function (ctx) {
        _this2.openAttachment(ctx.dataset.url);
      });
      this.menu.add('Rename', 'fas fa-edit').click(function (ctx) {
        var category = ctx.dataset.category;
        var filename = ctx.dataset.filename;

        _this2.renameAttachment(filename, category);
      });
      this.menu.add('Delete', 'fal fa-trash-alt').click(function (ctx) {
        var category = ctx.dataset.category;
        var filename = ctx.dataset.filename;

        _this2.deleteAttachment(filename, category);
      });
      this.menu.add('Copy name', 'fal fa-copy').click(function (ctx) {
        var filename = ctx.dataset.filename;
        copy(filename);
      });
      this.menu.add('Copy path', 'far fa-copy').click(function (ctx) {
        var category = ctx.dataset.category;
        var filename = ctx.dataset.filename;
        copy(category + '/' + filename);
      });
      this.menu.add('Copy url', 'fas fa-copy').click(function (ctx) {
        var url = ctx.dataset.url;
        copy(url);
      });
      this.menu.add('Edit image', 'fas fa-image', 'image-edit').click(function (ctx) {
        var category = ctx.dataset.category;
        var filename = ctx.dataset.filename;
        var url = ctx.dataset.url;

        _this2.imageEdit(url, category, filename);
      });
    }
  }, {
    key: "createViewModel",
    value: function createViewModel() {
      var _this3 = this;

      var formData = new FormData();
      formData.append('id', this.id);
      var collections = Object.keys(this.collections);

      for (var i = 0; i < collections.length; i++) {
        formData.append('collections[' + i + ']', collections[i]);
      }

      return this.handler.fetch.attachment('get', formData).then(function (res) {
        return res.json();
      }).then(function (attachments) {
        return Object({
          attachments: attachments,
          getClassNameForExtension: getClassNameForExtension,
          handler: _this3.handler
        });
      });
    }
  }, {
    key: "onRender",
    value: function onRender() {
      var _this4 = this;

      this.$$('close').listen('click', function () {
        _this4.close();
      });
      this.$$('attachment').listen('contextmenu', function (event, target) {
        event.preventDefault();

        if (target.dataset.type === 'image') {
          _this4.menu.enable('image-edit');
        } else {
          _this4.menu.disable('image-edit');
        }

        _this4.menu.show(event, target);
      }).listen('dragstart', function (event, target) {
        event.dataTransfer.setData('filename', target.dataset.filename);
        event.dataTransfer.setData('category', target.dataset.category);
        event.dataTransfer.setData('source:' + target.dataset.category, '');
        event.dataTransfer.setData('filename:' + target.dataset.filename, '');
        event.dataTransfer.setData('action', "copy");
      }).listen('dblclick', function (event, target) {
        if (target.dataset.url && event.target.tagName !== 'INPUT') {
          _this4.openAttachment(target.dataset.url);
        }
      });
      this.$$('trash').listen('dragover', function (even) {
        return event.preventDefault();
      }).listen('dragenter', function (event, target) {
        target.classList.remove('fal');
        target.classList.add('fas');
        event.preventDefault();
      }).listen('dragleave', function (event, target) {
        target.classList.remove('fas');
        target.classList.add('fal');
        event.preventDefault();
      }).listen('drop', function (event, target) {
        if (event.dataTransfer.getData('action') === 'copy') {
          _this4.deleteAttachment(event.dataTransfer.getData('filename'), event.dataTransfer.getData('category'));
        }
      });
      this.$$('attachment', function (node) {
        return node.overCounter = 0;
      }).listen('dragover', function (event) {
        return event.preventDefault();
      }).listen('dragenter', function (event, target) {
        target.overCounter++;

        if (event.dataTransfer.types.indexOf('source:' + target.dataset.category) !== -1 && event.dataTransfer.types.indexOf('filename:' + target.dataset.filename) === -1) {
          target.classList.add('dragover');
        }

        event.preventDefault();
      }).listen('dragleave', function (event, target) {
        target.overCounter--;
        if (target.overCounter === 0) target.classList.remove('dragover');
        event.preventDefault();
      }).listen('drop', function (event, target) {
        if (event.dataTransfer.types.indexOf('source:' + target.dataset.category) !== -1 && event.dataTransfer.types.indexOf('filename:' + target.dataset.filename) === -1) {
          event.preventDefault();
          event.stopImmediatePropagation();
          target.classList.remove('dragover');
          target.overCounter = 0;
          var filename = event.dataTransfer.getData('filename');
          var fileSource = event.dataTransfer.getData('category');

          _this4.reorderAttachment(filename, fileSource, target.dataset.ordinal);
        }
      });
      this.$$("category", function (node) {
        return node.overCounter = 0;
      }).listen('dragover', function (event) {
        return event.preventDefault();
      }).listen('dragenter', function (event, target) {
        target.overCounter++;

        if (event.dataTransfer.types.indexOf('source:' + target.dataset.category) === -1) {
          target.classList.add('dragover');
        }

        event.preventDefault();
      }).listen('dragleave', function (event, target) {
        target.overCounter--;
        if (target.overCounter === 0) target.classList.remove('dragover');
        event.preventDefault();
      }).listen('drop', function (event, target) {
        event.preventDefault();
        event.stopImmediatePropagation();
        target.classList.remove('dragover');
        target.overCounter = 0;

        if (event.dataTransfer.getData('action') === 'copy') {
          var method = event.shiftKey ? 'copy' : 'move';
          var fileTarget = target.dataset.category;
          var filename = event.dataTransfer.getData('filename');
          var fileSource = event.dataTransfer.getData('category');
          if (fileTarget !== fileSource) _this4.copyAttachment(method, filename, fileSource, fileTarget);
        } else {
          var files = event.dataTransfer.files;
          var category = target.dataset.category;

          _this4.uploadAttachment(files, category);
        }
      });
    }
  }, {
    key: "openAttachment",
    value: function openAttachment(url) {
      var win = window.open(url, '_blank');
      win.focus();
    }
  }, {
    key: "uploadAttachment",
    value: function uploadAttachment(files, collection) {
      var _this5 = this;

      var uploads = [];

      for (var i = 0; i < files.length; i++) {
        var file = files[i];
        var formData = new FormData();
        formData.append('id', this.id);
        formData.append('collection', collection);
        formData.append('file', file);
        uploads.push(this.handler.fetch.attachment('upload', formData));
      }

      Promise.all(uploads).finally(function () {
        return _this5.render();
      });
    }
  }, {
    key: "copyAttachment",
    value: function copyAttachment(action, filename, source, target) {
      var _this6 = this;

      var formData = new FormData();
      formData.append('id', this.id);
      formData.append('filename', filename);
      formData.append('source', source);
      formData.append('target', target);
      this.handler.fetch.attachment(action, formData).finally(function () {
        return _this6.render();
      });
    }
  }, {
    key: "deleteAttachment",
    value: function deleteAttachment(filename, collection) {
      var _this7 = this;

      var formData = new FormData();
      formData.append('id', this.id);
      formData.append('filename', filename);
      formData.append('collection', collection);
      this.handler.fetch.attachment('delete', formData).finally(function () {
        return _this7.render();
      });
    }
  }, {
    key: "crop",
    value: function crop(collection, filename, data) {
      var _this8 = this;

      var formData = new FormData();
      formData.append('id', this.id);
      formData.append('filename', filename);
      formData.append('collection', collection);
      formData.append('data', JSON.stringify(data));
      this.handler.fetch.attachment('crop', formData).finally(function () {
        return _this8.render();
      });
    }
  }, {
    key: "renameAttachment",
    value: function renameAttachment(filename, collection) {
      var _this9 = this;

      var newname = prompt('', filename);

      if (newname.trim() !== '' && newname !== filename) {
        var formData = new FormData();
        formData.append('collection', collection);
        formData.append('filename', filename);
        formData.append('newname', newname);
        formData.append('id', this.id);
        this.handler.fetch.attachment('rename', formData).finally(function () {
          return _this9.render();
        });
      }
    }
  }, {
    key: "reorderAttachment",
    value: function reorderAttachment(filename, collection, ordinal) {
      var _this10 = this;

      var formData = new FormData();
      formData.append('collection', collection);
      formData.append('filename', filename);
      formData.append('ordinal', ordinal);
      formData.append('id', this.id);
      this.handler.fetch.attachment('reorder', formData).finally(function () {
        return _this10.render();
      });
    }
  }, {
    key: "imageEdit",
    value: function imageEdit(url, category, filename) {
      var _this11 = this;

      MagicImageEditorModal.modalify({
        url: url
      }, function (data) {
        if (data !== false) _this11.crop(category, filename, data);
      });
    }
  }]);

  return MagicAttachmentsModal;
}(Brick)) || _class) || _class) || _class);
export { MagicAttachmentsModal as default };